import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DEFAULT_ROUTES from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { getProjectInfo } from "../../utils/api/project_apis";
import { STATUS } from "../../utils/api/sharedfunction";
import GhostLoader from "../Loaders/ghostloader";
import { selectProject } from "../../features/projects/ProjectSlice";
import { resetAllState } from "../../features/replayslice";
import { reset as resetQueryState } from "../../features/query/querySlice";

const withProjectInfo = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        const { project_id } = useParams();
        const selectedProjectId = useSelector((state) => state?.projects?.selectedProject?.id);
        const dispatch = useDispatch();
        const [loading, setLoading] = useState(true);
        useEffect(() => {
            (async () => {
                if(!selectedProjectId && !project_id) {
                    navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`);
                    setLoading(false);
                    return;
                } else if(project_id !== selectedProjectId && project_id) {
                    const result = await getProjectInfo();
                    if(result.status === STATUS.SUCCESS) {
                        dispatch(selectProject(result.data || {}));
                        dispatch(resetAllState());
                        dispatch(resetQueryState());
                    } else {
                        navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`);
                        setLoading(false);
                        return;
                    }
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })();
        }, [project_id, selectedProjectId, navigate]);

        if(loading) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };
};
export default withProjectInfo;